export enum TagVariant {
  INFO = 'info',
  ERROR = 'error',
  SUCCESS = 'success',
}
